import { JoonColorExpanded, JoonUIColor, Typography } from "@joonapp/web-shared"

type Props = {
  profileUrl?: string
  userName: string
  size?: "small" | "medium" | "large"
  color?: "orange" | "purple"
}

const sizes = {
  small: { textSize: "bodyXSmall", heightWidth: "24px" },
  medium: { textSize: "body", heightWidth: "36px" },
  large: { textSize: "h2", heightWidth: "56px" },
} as const

const colorThemes = {
  orange: {
    primaryColor: JoonColorExpanded.orange300,
    secondaryColor: JoonColorExpanded.orange100,
  },
  purple: {
    primaryColor: JoonColorExpanded.purple600,
    secondaryColor: JoonColorExpanded.purple100,
  },
  green: {
    primaryColor: JoonColorExpanded.green600,
    secondaryColor: JoonColorExpanded.green100,
  },
}

const ProfileImage = ({
  profileUrl,
  userName,
  size = "large",
  color = "orange",
}: Props) => {
  const { textSize, heightWidth } = sizes[size]
  const { primaryColor, secondaryColor } = colorThemes[color]

  if (!profileUrl)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: heightWidth,
          minWidth: heightWidth,
          borderRadius: "50%",
          height: heightWidth,
          backgroundColor: secondaryColor,
          border: `1px solid ${JoonUIColor.border.inverted}`,
        }}
      >
        <Typography variant={textSize} color={primaryColor}>
          {userName.slice(0, 1).toUpperCase()}
        </Typography>
      </div>
    )

  return (
    <img
      src={profileUrl}
      alt="channel cover"
      style={{
        minWidth: heightWidth,
        width: heightWidth,
        borderRadius: "50%",
        maxHeight: heightWidth,
        objectFit: "cover",
      }}
    />
  )
}

export default ProfileImage
